import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=084b66ff&scoped=true&"
import script from "./Rating.vue?vue&type=script&lang=ts&"
export * from "./Rating.vue?vue&type=script&lang=ts&"
import style0 from "./Rating.vue?vue&type=style&index=0&id=084b66ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b66ff",
  null
  
)

export default component.exports